var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5674 56.9712C78.4031 38.9393 61.7974 13.8331 48.8873 2.76578C35.9769 13.8344 19.3714 38.9393 24.2072 56.9712C30.8147 81.6096 66.9615 81.6096 73.5674 56.9712ZM32.7141 15.6014C28.9125 9.27206 24.1356 3.65216 19.8747 0C9.83902 8.6045 -3.0691 28.1214 0.690795 42.1391C3.30976 51.9054 11.8975 56.6894 20.3718 56.4949C17.6561 43.625 24.0435 28.0636 32.7166 15.5986L32.7141 15.6014ZM67.1192 60.3132C70.0479 54.7721 68.4037 43.1592 66.0642 38.9971C64.2825 35.8298 65.0207 37.6999 65.0515 40.5189C65.1224 46.8058 64.4365 52.849 59.9555 57.618C56.3568 61.4453 63.987 66.2341 67.1191 60.3115L67.1192 60.3132Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.118cd77d4e2249969e52ee2707a1198d.svg";
export { ForwardRef as ReactComponent };